var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2"},[_c('MapaDeSeparacao')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }